module.exports = __webpack_public_path__ + "img/889-aefc22.png";